
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { LoginComponent } from "src/app/auth/components/login/login.component";
import { EventService } from "src/app/core/services/event.service";
import { AuthService } from "src/app/core/services/auth.service";


@Component({
  selector: 'app-public-gallery',
  templateUrl: './public-gallery.component.html',
  styleUrls: ['./public-gallery.component.scss'],
  providers: [LoginComponent],
})
export class PublicGalleryComponent implements OnInit {
  eventDetail: any;
  eventDetailNew: any;
  isLoading = true;

  constructor(
    private router: Router,
    private authService: AuthService,
    public loginComponent: LoginComponent,
    private location: Location,
    private eventService: EventService
  ) { }

  ngOnInit(): void {
    this.eventDetail = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem('EventDetails'))));
    this.eventService.pwaFetchData(localStorage.getItem('eventId')).subscribe(
      (data: any) => {
        if (data?.udid) {
          localStorage.setItem('udid', data.udid);
        }
        this.isLoading = false;
        this.eventDetailNew = data.data;
        this.eventDetailNew.files.forEach((element: any) => {
          if (element.mime_type === "video") {
            element.dataVideo = {
              source: [{ src: element.fileUrl, type: "video/mp4" }],
              attributes: {
                preload: false,
                playsinline: true,
                controls: true,
              },
            };
            element.dataVideo = JSON.stringify(element.dataVideo);
          }
        });
      }
    )
  }

  scrollToTop(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  getLatestPhotos() {
    this.eventDetailNew = [];
    this.isLoading = true;
    this.eventService.pwaFetchData(localStorage.getItem('eventId')).subscribe(
      (data: any) => {
        this.isLoading = false;

        if (data?.udid) {
          localStorage.setItem('udid', data.udid);
        }
        this.eventDetailNew = data.data;
        this.eventDetailNew.files.forEach((element: any) => {
          if (element.mime_type === "video") {
            element.dataVideo = {
              source: [{ src: element.fileUrl, type: "video/mp4" }],
              attributes: {
                preload: false,
                playsinline: true,
                controls: true,
              },
            };
            element.dataVideo = JSON.stringify(element.dataVideo);
          }
        });
      }
    );
  }



  signUpWithGoogle() {
    this.authService
      .signOut()
      .then((res) => {
        localStorage.clear();
        this.router.navigateByUrl("/auth/login", { replaceUrl: true });
        // this.loginComponent.signUpWithGoogle();
      })
      .catch((err) => {
        // console.error(err); //__CONSOLE_LOG__
      });
  }

  logout() {
    this.authService
      .signOut()
      .then((res) => {
        this.router.navigateByUrl(
          "/auth/login"
        );
      })
      .catch((err) => {
        // console.error(err); //__CONSOLE_LOG__
      });
  }

  goBack() {
    this.location.back();
  }
}
